import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingIndicator = ({ isProcessing, isSuccess, isError }) => {
  if (!isProcessing && !isSuccess && !isError) return null;

  return (
    <div className="fixed inset-0 z-1002 flex items-center justify-center bg-background/90 backdrop-blur-md">
      <div className="bg-card rounded-2xl p-8 shadow-elevation-lg max-w-md w-full mx-4 text-center">
        {isProcessing && (
          <>
            <div className="animate-spin h-12 w-12 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
            <h3 className="text-lg font-semibold text-foreground mb-2">Processing Payment</h3>
            <p className="text-muted-foreground text-sm">
              Please wait while we securely process your payment...
            </p>
            <div className="mt-4 text-xs text-muted-foreground">
              Do not close this window or refresh the page
            </div>
          </>
        )}
        
        {isSuccess && (
          <>
            <div className="h-12 w-12 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle" size={24} className="text-success" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">Payment Successful!</h3>
            <p className="text-muted-foreground text-sm mb-4">
              Your payment has been processed successfully. Redirecting to candidate profile...
            </p>
            <div className="animate-pulse text-xs text-muted-foreground">
              Unlocking candidate information...
            </div>
          </>
        )}
        
        {isError && (
          <>
            <div className="h-12 w-12 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="XCircle" size={24} className="text-destructive" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">Payment Failed</h3>
            <p className="text-muted-foreground text-sm mb-4">
              We couldn't process your payment. Please check your payment details and try again.
            </p>
            <div className="text-xs text-muted-foreground">
              If the problem persists, please contact our support team
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProcessingIndicator;